// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"72af2d39","809":"f5c2abcc"}[chunkId] + ".chunk.js";
};